/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Eisubscaleoverallvibestrong4Inputs */



/**
* | output |
* | --- |
* | "You notice emotions in yourself and others, read facial expressions, tone and gestures, and find your way around the emotional background of a situation." |
*
* @param {Eisubscaleoverallvibestrong4Inputs} inputs
* @param {{ locale?: "ru" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const eisubscaleoverallvibestrong4 = /** @type {((inputs?: Eisubscaleoverallvibestrong4Inputs, options?: { locale?: "ru" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Eisubscaleoverallvibestrong4Inputs, { locale?: "ru" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("You notice emotions in yourself and others, read facial expressions, tone and gestures, and find your way around the emotional background of a situation.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Notas bien las emociones en ti y en los demás, lees gestos, tono y ademanes, y te orientas en el clima emocional de la situación.")
	return /** @type {LocalizedString} */ ("Ты хорошо замечаешь эмоции в себе и других, считываешь мимику, тон, жесты и ориентируешься в эмоциональном фоне ситуации.")
});
export { eisubscaleoverallvibestrong4 as "eiSubscaleOverallVibeStrong" }